export const CONTACT_INFO = {
  phone: '020 8202 5160',
  email: 'enquiries@bears-pts.co.uk'
} as const

export const COMPANY_INFO = {
  name: 'BEARS Patient Transport Service Ltd',
  companyNumber: '4269 3936',
  location: 'London, United Kingdom'
} as const

export const ROUTES = {
  home: '/',
  about: '/about',
  services: '/services',
  contact: '/contact',
  careers: '/careers',
  news: '/news',
  team: '/team',
  cubs: '/cubs',
  fleet: '/fleet',
  compliments: '/compliments'
} as const

export const SERVICE_ROUTES = {
  nepts: '/services/nepts',
  paramedic: '/services/paramedic',
  bariatric: '/services/bariatric',
  criticalRetrieval: '/services/critical-retrieval',
  ecmo: '/services/ecmo',
  highDependance: '/services/high-dependance',
  mentalHealth: '/services/mental-health',
  neonatal: '/services/neonatal',
  clinicalHelpline: '/services/clinical-helpline'
} as const
